import * as React from "react"
import { CmsVendor } from "@modules/graphql/types"
import { CosmicJsAuthForm } from "./CosmicJsAuthForm"
import { ShopifyAuthForm } from "./ShopifyAuthForm"

export type CmsOAuthFormWithFieldsProps = {
  siteId: string
  cmsVendor: string
  isProvisioning?: boolean
  onComplete: () => void
  onCancel: () => void
}

export function CmsOAuthFormWithFields({
  siteId,
  cmsVendor,
  isProvisioning,
  onCancel,
  onComplete,
}: CmsOAuthFormWithFieldsProps) {
  switch (cmsVendor) {
    case CmsVendor.Cosmicjs: {
      return (
        <CosmicJsAuthForm
          siteId={siteId}
          isProvisioning={isProvisioning}
          onComplete={onComplete}
          onCancel={onCancel}
        />
      )
    }
    case CmsVendor.Shopify: {
      return (
        <ShopifyAuthForm
          siteId={siteId}
          isProvisioning={isProvisioning}
          onComplete={onComplete}
          onCancel={onCancel}
        />
      )
    }
    default: {
      return <div />
    }
  }
}
